module.exports = " <div class=\"dv-alert-box {{vm.alertTypeClass}} {{vm.sizeClass}}\"> <div class=\"dv-alert-box__message\" ng-transclude> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-alert-box/dv-alert-box.html
// module id = 1Gel
// module chunks = 0